export default __webpack_public_path__ + "static/media/img5.1b2bffd3.jpg";